import { render, staticRenderFns } from "./PortfolioDesignerView.vue?vue&type=template&id=3774d688&"
import script from "./PortfolioDesignerView.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortfolioDesignerView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports